module.exports = __webpack_public_path__ + "img/new.0182f107.svg";